import React from 'react';
import { Table } from 'reactstrap';
import { clientInformationHeaders } from './constants';

function ClientInformation({ data }) {
  const renderPublicOfficial = index => {
    if (data[index]?.PublicOfficial === 'Y') {
      return 'Yes';
    }
    return 'No';
  };
  const renderClientInformationBody = () => {
    if (!data || data?.length === 0) {
      return (
        <tr>
          <td colSpan="7" className="text-center">
            No flight information available.
          </td>
        </tr>
      );
    }
    // Assuming flightInformation is an array of objects with properties matching the headers
    return data?.map((client, index) => (
      <tr key={index}>
        <td
          style={{
            width: '320px',
            overflowX: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {client?.ClientName}
        </td>
        <td
          style={{
            width: '320px',
            overflowX: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {client?.Company}
        </td>
        <td>{client?.ContactNo}</td>
        <td
          style={{
            width: '320px',
            overflowX: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {client?.ProjectName}
        </td>
        <td>{renderPublicOfficial(index)}</td>
      </tr>
    ));
  };
  return (
    <div className="d-flex flex-column gap-2">
      <div>
        <span className="fw-semibold">Client Information</span>
      </div>
      <div className="table-responsive">
        <Table className="ba-table">
          <thead>
            <tr>
              {clientInformationHeaders.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>{renderClientInformationBody()}</tbody>
        </Table>
      </div>
    </div>
  );
}

export default ClientInformation;
